"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/button-has-type */
/** cccisd-click-button provides your a simple button. It can have confirm message, loading or disabled state. */
var _default = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _default, [].concat(args));
    _defineProperty(_this, "_clicked", function (e) {
      e.preventDefault();
      if (_this.props.isConfirm) {
        (0, _cccisdConfirm["default"])(_this.props.confirmationMessage).then(function () {
          _this.props.onClick();
        });
      } else {
        _this.props.onClick();
      }
    });
    return _this;
  }
  _inherits(_default, _React$Component);
  return _createClass(_default, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        title = _this$props.title,
        isDisabled = _this$props.isDisabled,
        isLoading = _this$props.isLoading;
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: this.props.type,
        id: this.props.id,
        className: className,
        style: this.props.style,
        disabled: isDisabled || isLoading,
        onClick: this._clicked
      }, isLoading && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].loader
      }), title);
    }
  }]);
}(_react["default"].Component);
_defineProperty(_default, "propTypes", {
  /** The title of the button. */
  title: _propTypes["default"].node,
  /** The class name of the button. */
  className: _propTypes["default"].string,
  /** The ID of the button. */
  id: _propTypes["default"].string,
  /** Function called when the button is clicked. */
  onClick: _propTypes["default"].func,
  /** Show a confirm message or not? */
  isConfirm: _propTypes["default"].bool,
  /** Confirm message if "isConfirm" is true. */
  confirmationMessage: _propTypes["default"].node,
  /** Show a loading spinner or not? */
  isLoading: _propTypes["default"].bool,
  /** Show the disabled state or not? */
  isDisabled: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  /** Button type */
  type: _propTypes["default"].string
});
_defineProperty(_default, "defaultProps", {
  title: 'Submit',
  className: 'btn btn-secondary',
  id: null,
  onClick: function onClick() {},
  isConfirm: false,
  confirmationMessage: 'Are you sure?',
  isLoading: false,
  isDisabled: false,
  style: {},
  type: 'submit'
});